import React, { Component } from 'react';
import { TagItem } from './TagItem';
import RegexUtils from '../../../utils/RegexUtils';

class MyTags extends Component {
  constructor(props) {
    super(props);
    this.deleteTag = this.deleteTag.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onPaste = this.onPaste.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.contentMyTags = this.contentMyTags.bind(this);
    this.clearTag = this.clearTag.bind(this);
    this.state = {
      confirmCancel: false,
    };
  }

  componentWillReceiveProps() {
    this.setState({ confirmCancel: false });
  }

  onFocus(event) {
    event.target.value.length === 0
      ? this.setState({ displayDelTag: false })
      : this.setState({ displayDelTag: true });
  }

  onPaste(event) {
    event.preventDefault();
  }

  onBlur() {
    this.props.newTagInput(this.refs.addNewTagInput.value);
    setTimeout(() => {
      this.setState({ displayDelTag: false });
    }, 150);
  }

  onKeyPress(event) {
    if (!RegexUtils.isValid(event.key, RegexUtils.regexes.customTag)) {
      event.preventDefault();
    }
    event.target.value.length === 0
      ? this.setState({ displayDelTag: false })
      : this.setState({ displayDelTag: true });
    this.props.handleKeyPress(event);
  }
  contentMyTags() {
    if (this.props.data) {
      let myTags = this.props.data.map((mytag, i) => {
        return (
          <li key={i}>
            <TagItem
              editTagInput={this.props.editTagInput}
              flagForAddTag={this.props.flagForAddTag}
              flagForEditTag={this.props.flagForEditTag}
              handleChangeOfTag={this.props.handleChangeOfTag}
              mytag={mytag}
              assignTag={this.props.assignTag}
              deleteTag={this.deleteTag}
              getClass={this.props.getClass}
              content={this.props.content}
              cssActiveClassForSelectedTags={
                this.props.cssActiveClassForSelectedTags
              }
              itemKey={i}
            />
          </li>
        );
      });
      return <ul>{myTags}</ul>;
    }
  }

  clearTag() {
    const event = { target: { value: '' } };
    this.refs.addNewTagInput.value = '';
    this.setState({ displayDelTag: false });
    this.props.handleChangeOfTag(event);
  }
  deleteTag(e) {
    this.props.deleteTag(this.props.data[e].key);
  }

  render() {
    // FinancialStoriesStore.getTagLoadStatus() //replace in place of true
    if (true) {
      return (
        <div
          className={`tag-list ${this.props.noTagSelection ? 'tagIndex' : ''}`}
        >
          {!this.props.flagForEditTag && !this.props.flagForAddTag && (
            <span
              className="icon icon-information"
              onClick={this.props.onTagInfoClick}
            />
          )}
          <div>{this.contentMyTags()}</div>

          {!this.props.flagForEditTag && (
            <div className="add-tag text-center">
              {!this.props.flagForAddTag &&
                this.props.data &&
                this.props.data.length < 5 && (
                  <button
                    name="Add a new tag"
                    className="btn btn-link"
                    onClick={this.props.handleAddTagButton}
                  >
                    Add a new tag
                  </button>
                )}
              {this.props.flagForAddTag && (
                <div className="input-tag">
                  <span className="icon icon-tag" />
                  <input
                    type="text"
                    maxLength={16}
                    ref="addNewTagInput"
                    value={this.props.newTagValue}
                    onPaste={this.onPaste}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    onChange={this.props.handleKeyPress}
                    pattern={RegexUtils.regexes.customTag}
                    autoFocus
                    onKeyPress={this.onKeyPress}
                    onKeyUp={this.onKeyPress}
                  />
                  <a
                    onClick={this.clearTag}
                    className="searchClear"
                    style={{
                      display: `${this.state.displayDelTag ? 'block' : 'none'}`,
                    }}
                  >
                    <span className="icon icon-clear" />
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      );
    } else {
      return <div className="loader-sidebar" />;
    }
  }
}
export { MyTags };
